import React from 'react';
import {useSelector} from 'react-redux';
import {ExternalLinkIcon} from '../../icons/Icons';
import {FormattedMessage} from 'react-intl';

function ShopifyMultipassLogin(props) {
  const shopify_multipass_url = useSelector((state)=>state.settings.shopify_multipass_url)
  if(shopify_multipass_url){
    return  <small className={"d-block"}>
      <a href={shopify_multipass_url} rel={"noopener noreferrer nofollow"}
         target={"_blank"}><span className="mr-1"><FormattedMessage id={"Access customer account"} /></span><ExternalLinkIcon /></a>
    </small>
  }
  return null;
}

export default ShopifyMultipassLogin;
